import { render, staticRenderFns } from "./Roman.vue?vue&type=template&id=43e4597c"
import script from "./Roman.vue?vue&type=script&lang=ts"
export * from "./Roman.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports